import { render } from "./pocetna.vue?vue&type=template&id=3327c248&scoped=true"
import script from "./pocetna.vue?vue&type=script&lang=js"
export * from "./pocetna.vue?vue&type=script&lang=js"

import "./pocetna.vue?vue&type=style&index=0&id=3327c248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3327c248"]])

export default __exports__